var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.485 20.154-6.262-6.262a5.5 5.5 0 0 1-1.725.989q-.975.35-1.96.35-2.402 0-4.066-1.663-1.665-1.664-1.664-4.065 0-2.4 1.663-4.067t4.064-1.667q2.402 0 4.068 1.664T15.269 9.5q0 1.042-.369 2.017a5.5 5.5 0 0 1-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361-1.37-3.36-3.36-1.37q-1.992 0-3.361 1.37T4.808 9.5q0 1.99 1.37 3.36t3.36 1.37"
  })));
};
export default SvgMagnifyingGlass;